/* KIS verzendgarantie-schakelaar (snippets/kis-verzendgarantie.liquid). Zet het product 'shipping-insurance'
   in of uit de wagen en ververst daarna lade, cartpagina en het tas-icoon met de Section Rendering API,
   op dezelfde manier als Dawn's cart.js / cart-drawer.js.
   Standaard aan: ligt er iets in de wagen zonder garantie, dan wordt hij toegevoegd. Zet de klant hem uit,
   dan onthouden we dat (localStorage) tot de wagen weer leeg is. */
if (!customElements.get('kis-verzendgarantie')) {
  const KIS_VG_OPTOUT_KEY = 'kis-vg-optout';

  class KisVerzendgarantie extends HTMLElement {
    static busy = false;

    connectedCallback() {
      this.variantId = Number(this.dataset.variantId);
      this.input = this.querySelector('[data-kis-vg-input]');
      if (this.input) {
        this.input.addEventListener('change', () => {
          this.setOptOut(!this.input.checked);
          this.setInsured(this.input.checked);
        });
      }

      if (this.hasAttribute('data-orphan')) {
        /* Alleen de garantie ligt nog in de wagen (laatste product verwijderd): garantie er ook uit */
        this.setOptOut(false);
        if (this.dataset.inCart === 'true') this.setInsured(false);
      } else if (this.input && this.dataset.inCart === 'false' && !this.hasOptedOut()) {
        this.setInsured(true);
      }
    }

    hasOptedOut() {
      try {
        return window.localStorage.getItem(KIS_VG_OPTOUT_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    setOptOut(optedOut) {
      try {
        if (optedOut) window.localStorage.setItem(KIS_VG_OPTOUT_KEY, '1');
        else window.localStorage.removeItem(KIS_VG_OPTOUT_KEY);
      } catch (e) {
        /* localStorage niet beschikbaar (privévenster): dan alleen geen geheugen voor 'uit' */
      }
    }

    sectionsToRender() {
      const sections = [];
      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      const items = document.getElementById('main-cart-items');
      const footer = document.getElementById('main-cart-footer');
      if (items) sections.push(items.dataset.id);
      if (footer) sections.push(footer.dataset.id);
      if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
      return sections;
    }

    async setInsured(insured) {
      if (KisVerzendgarantie.busy) return;
      KisVerzendgarantie.busy = true;
      this.classList.add('is-loading');

      const sections = this.sectionsToRender();
      const url = `${insured ? routes.cart_add_url : routes.cart_change_url}.js`;
      const body = insured
        ? { items: [{ id: this.variantId, quantity: 1 }], sections, sections_url: window.location.pathname }
        : { id: String(this.variantId), quantity: 0, sections, sections_url: window.location.pathname };

      try {
        const response = await fetch(url, { ...fetchConfig(), body: JSON.stringify(body) });
        const state = await response.json();
        if (state.status || state.errors) throw new Error(state.description || state.errors);
        if (state.sections) this.renderSections(state.sections, state.item_count);
      } catch (error) {
        console.error('[KIS verzendgarantie]', error);
        if (this.input) this.input.checked = !insured;
      } finally {
        KisVerzendgarantie.busy = false;
        this.classList.remove('is-loading');
      }
    }

    /* itemCount komt alleen mee bij /cart/change (uitzetten); dan ook de lege-wagenstand bijwerken zoals cart.js */
    renderSections(sections, itemCount) {
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

      if (typeof itemCount === 'number') {
        const empty = itemCount === 0;
        document.querySelector('cart-drawer')?.classList.toggle('is-empty', empty);
        document.querySelector('cart-items')?.classList.toggle('is-empty', empty);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
      }

      if (sections['cart-drawer']) {
        const target = document.querySelector('cart-drawer .drawer__inner');
        const source = parse(sections['cart-drawer']).querySelector('.drawer__inner');
        if (target && source) target.innerHTML = source.innerHTML;
      }

      [
        ['main-cart-items', '#main-cart-items .js-contents'],
        ['main-cart-footer', '#main-cart-footer .js-contents'],
      ].forEach(([id, selector]) => {
        const element = document.getElementById(id);
        const html = element && sections[element.dataset.id];
        const target = document.querySelector(selector);
        const source = html && parse(html).querySelector(selector);
        if (target && source) target.innerHTML = source.innerHTML;
      });

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const source = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (source) bubble.innerHTML = source.innerHTML;
      }
    }
  }

  customElements.define('kis-verzendgarantie', KisVerzendgarantie);
}
